









































import { Component, Mixins, } from "vue-property-decorator";
import { SearchConditionPresetSortMixin } from "../mixins";

@Component
export default class PresetSortArea extends Mixins(SearchConditionPresetSortMixin) {
}
